import BaseService from './base/base.service'

export default class CartSessionService extends BaseService {

    constructor(){
        super('cartsession')
    }
}